import SearchableSelect from '../Form/SearchableSelect';
import { defaultOptionLabel, defaultOptionValue } from '../../utils/selectOptions';

/**
 * Compact searchable select used by add/edit user form sections.
 */
const FormSelect = ({
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  required = false,
  className = '',
  disabled = false,
  creatable = false,
  getOptionLabel = defaultOptionLabel,
  getOptionValue = defaultOptionValue,
}) => (
  <SearchableSelect
    name={name}
    value={value}
    onChange={onChange}
    options={options}
    placeholder={placeholder}
    required={required}
    disabled={disabled}
    className={className}
    creatable={creatable}
    getOptionLabel={getOptionLabel}
    getOptionValue={getOptionValue}
  />
);

export default FormSelect;
